import { useEffect, useMemo, useState } from 'react';
import { Box, Text, Button, CloudinaryImage } from '@stitch-fix/mode-react';
import type { SupportedBusinessLine } from '../../onboarding/Onboarding';
import styles from './CurrentGalleryEmpty.module.scss';
const images: Record<SupportedBusinessLine, string[]> = {
  WOMENS: ['v1782850119/vision/assets/women_try_it_out_1.png', 'v1782850570/vision/assets/women_try_it_out_2.png', 'v1782850571/vision/assets/women_try_it_out_3.png'],
  MENS: ['v1782850972/vision/assets/men_try_it_out_1.png', 'v1782850972/vision/assets/men_try_it_out_2.png', 'v1782850973/vision/assets/men_try_it_out_3.png']
};
export const CurrentGalleryEmpty = ({
  businessLine = 'WOMENS'
}: {
  businessLine?: SupportedBusinessLine;
}) => {
  const slides = useMemo(() => images[businessLine], [businessLine]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedSlides, setLoadedSlides] = useState<Record<string, boolean>>({});
  useEffect(() => {
    setCurrentIndex(0);
    setLoadedSlides({});
  }, [slides]);
  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const interval = setInterval(() => {
      setCurrentIndex(prev => {
        const nextLoadedIndex = slides.findIndex((slide, index) => {
          const isAfterCurrent = index > prev;
          return isAfterCurrent && loadedSlides[slide];
        });
        if (nextLoadedIndex !== -1) return nextLoadedIndex;
        const firstLoadedIndex = slides.findIndex(slide => loadedSlides[slide]);
        return firstLoadedIndex !== -1 && firstLoadedIndex !== prev ? firstLoadedIndex : prev;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, [loadedSlides, slides]);
  return <Box style={{
    textAlign: 'left',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  }} p={1.5} bgColor="gray-95">
      <Text setting="subtitle-medium" color="blue-45" mb={0.5} align="center">
        No images available
      </Text>
      <Box width="280px" className={styles.media}>
        {slides.map((mediaPath, index) => <Box key={mediaPath} className={`${styles.image} ${index === currentIndex ? styles.active : ''}`}>
            <CloudinaryImage baseUrl="https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/" mediaPath={mediaPath} sizes={{
          sm: 560
        }} alt="No images available" onLoad={() => {
          setLoadedSlides(prev => ({
            ...prev,
            [mediaPath]: true
          }));
        }} transforms={{
          e: ['replace_color:f0f1f3:200:ffffff']
        }} />
          </Box>)}
      </Box>
      <Box maxWidth="350px">
        <Text setting="body-medium" color="blue-45" my={1.5} align="center">
          Pick from a selection of a Stylist-approved outfits to generate new
          Vision images
        </Text>
      </Box>
      <Button as="a" href="https://www.stitchfix.com/shop/looks/trending">
        Browse outfits
      </Button>
    </Box>;
};